import InAppMessage from "./in-app-message.js";
import { DOMUtils as de } from "../../util/dom-utils.js";
export default class SlideUpMessage extends InAppMessage {
  constructor(e, t, s, o, i, r, n, d, a, u, p, m, c, l, v, x, f, h, g, I, M) {
    (x = x || InAppMessage.th.Mh),
      (v = v || InAppMessage.th.Dh),
      super(
        e,
        (t = t || InAppMessage.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
      ),
      (this.Te = InAppMessage.TextAlignment.START);
  }
  xe() {
    return !1;
  }
  Ge() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  Ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    de.no(t, !0, !0) ||
      (this.slideFrom === InAppMessage.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.Ah(e);
  }
  tt() {
    return super.tt(SlideUpMessage.et);
  }
  static an(e) {
    return new SlideUpMessage(
      e[InAppMessage.it.ea],
      e[InAppMessage.it.ra],
      e[InAppMessage.it.Sh],
      e[InAppMessage.it.jt],
      e[InAppMessage.it.sa],
      e[InAppMessage.it.ta],
      e[InAppMessage.it.URI],
      e[InAppMessage.it.ia],
      e[InAppMessage.it.oa],
      e[InAppMessage.it.pa],
      e[InAppMessage.it.ma],
      e[InAppMessage.it.nt],
      e[InAppMessage.it.ua],
      e[InAppMessage.it.ca],
      e[InAppMessage.it.fa],
      e[InAppMessage.it.da],
      e[InAppMessage.it.la],
      e[InAppMessage.it.ga],
      e[InAppMessage.it.ja],
      e[InAppMessage.it.ba],
      e[InAppMessage.it.CSS],
    );
  }
}
SlideUpMessage.et = InAppMessage.qe.pn;
